import template from './admin-navigation.html';

AdminNavigation.DIRECTIVE_NAME = 'ktAdminNavigation';
export default function AdminNavigation() {
    return {
        restrict: 'A',
        controller: AdminNavigationController,
        controllerAs: 'adminNavigationCtrl',
        template,
        bindToController: true,
        link,
    };

    function link($scope, $elem, $attrs, ktAdminNavigationCtrl) {
        ktAdminNavigationCtrl.$onInit();
    }
}

export function AdminNavigationController(
    adminNavigationService
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        menuItems: [],
    });

    function $onInit() {
        vm.menuItems = adminNavigationService.getMenuItems();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-navigation/admin-navigation-component.js